import { createContext } from "react";
import { ServerEnvironmentInfo } from "./ServerEnvironment";

export const ServerEnvironmentContext = createContext<
  ServerEnvironmentInfo | undefined
>(undefined);
